import styled from "@emotion/styled"
import Image from "next/image"
import { Dispatch, SetStateAction } from "react"
import { HomeIcon } from "ui/icons"

import colors from "theme/colors"
import { CustomBreadcrumbs, Desktop, Mobile, NewText, TitleWithLine } from "ui"
import { extractProperty } from "utils"

import { getUmbracoMediaUrl } from "utils/utils"
import ContactFormSwitch from "./ContactFormSwitch"
import { StyledNewText } from "./styles"

const StyledDiv = styled.div``

const StyledContactUs = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  ${(props) => props.theme.breakpoints.up("md")} {
    grid-template-columns: 1fr 640px;
    gap: 50px;
    }
    ${(props) => props.theme.breakpoints.up("lg")} {
      grid-template-columns: 1fr 902px;
      gap: 40px;
  }
`

const StyledImageContainer = styled.div`
   position: relative;
   aspect-ratio: 375/444;
   width: 100%;
   max-height: 444px;
  ${(props) => props.theme.breakpoints.up("md")} {
  aspect-ratio: 640/606;
  max-height: 606px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    max-height: 981px;
     aspect-ratio: 902/981;
    }
`
const StyledPad = styled.div`
  ${(props) => props.theme.breakpoints.down("md")} {
    padding-left: 20px;
  }
`

const DesktopPad = styled.div`
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-left: 112px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    padding-left: 240px;
  }
`
const StyledFormDiv = styled.div`
  padding-right: 20px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-right: 0px;
  }
`

const StyledTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 15px;
    ${(props) => props.theme.breakpoints.only("md")} {
    gap: 0px;
    }
`

const StyledGlobalTitle = styled(NewText)`
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-top: 16px;
    }
`

type ContactUsMainProps = {
  selectedValue: number
  setSelectedValue: Dispatch<SetStateAction<number>>
  data: any
}

function ContactUsMain({
  selectedValue,
  setSelectedValue,
  data,
}: ContactUsMainProps) {

  const globalTitle = extractProperty(data, "globalTitle")
  const globalText = extractProperty(data, "globalText")
  const imageForMobile = extractProperty(data, "imageForMobile")
  const imageForDescktop = extractProperty(data, "imageForDescktop")

  return (
    <>
      <StyledPad>
        <StyledDiv>
          <Mobile>
            <CustomBreadcrumbs
              current={{ title: "צרו קשר", url: `/` }}
              parents={[{ title: <HomeIcon />, url: "/" }]}
            />
          </Mobile>
          <StyledContactUs>

            <DesktopPad>
              <Desktop>
                <CustomBreadcrumbs
                  current={{ title: "צרו קשר", url: `/` }}
                  parents={[{ title: <HomeIcon />, url: "/" }]}
                />
              </Desktop>
              <StyledFormDiv>
                <StyledTextWrapper>
                  <TitleWithLine
                    title={"צרו קשר"}
                    titleColor={colors.black}
                    largeDesktopFontSize={64}
                    titleFontSize={42}
                    component={"h1"}
                    noMobileMargin
                    marginTop={20}
                  />
                  <StyledGlobalTitle
                    component={"p"}
                    largeDesktopFontSize={24}
                    desktopFontSize={16}
                    desktopLineHeight={"140%"}
                    mobileFontSize={18}
                    mobileLineHeight={"24px"}
                    desktopFontWeight={400}
                    mobileFontWeight={400}
                  >{globalTitle}
                  </StyledGlobalTitle>

                  <StyledNewText
                    component={"p"}
                    largeDesktopFontSize={18}
                    desktopFontSize={16}
                    desktopLineHeight={"140%"}
                    mobileFontSize={18}
                    mobileLineHeight={"24px"}
                    desktopFontWeight={400}
                    mobileFontWeight={400}
                    dangerouslySetInnerHTML={{ __html: globalText }}
                  >
                  </StyledNewText>
                </StyledTextWrapper>
                <ContactFormSwitch
                  setSelectedValue={setSelectedValue}
                  selectedValue={selectedValue}
                  data={data}
                />
              </StyledFormDiv>
            </DesktopPad>
            <Desktop>
              <StyledImageContainer>
                <Image
                  quality={85}
                  src={getUmbracoMediaUrl(imageForDescktop)}
                  alt="contact us"
                  fill
                />
              </StyledImageContainer>
            </Desktop>
          </StyledContactUs>
        </StyledDiv>
      </StyledPad>
      <Mobile>
        <StyledImageContainer>
          <Image
            quality={85}
            src={getUmbracoMediaUrl(imageForMobile)}
            alt="contact us"
            fill
          />
        </StyledImageContainer>
      </Mobile>
    </>
  )
}

export default ContactUsMain
